// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as apollo from "@apollo/client";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { setContext } from "@apollo/client/link/context";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { onError } from "@apollo/client/link/error";
import { useUPSClient } from "./contexts/upsClientProvider";
import { useAuthnClient } from "./contexts/authnClientProvider";
import type {
  ApolloCache,
  DefaultContext,
  OperationVariables,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from "@apollo/client/core";

export const Clients = {
  UPS: "UPS",
  Authn: "Authn",
} as const;

type ClientsType = keyof typeof Clients;

const useClient = (client: ClientsType) => {
  const upsClient = useUPSClient();
  const authnClient = useAuthnClient();

  const mapper = {
    [Clients.UPS]: upsClient,
    [Clients.Authn]: authnClient,
  };

  const actualClient = mapper[client];

  if (!actualClient) {
    throw new Error(`${client} is not configure.`);
  }

  return actualClient;
};

export const useMutation = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TData = any,
  TVariables = OperationVariables,
  TContext = DefaultContext,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TCache extends ApolloCache<any> = ApolloCache<any>,
>(
  client: ClientsType,
  ...args: Parameters<typeof apollo.useMutation>
) => {
  const actualClient = useClient(client);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return apollo.useMutation<TData, TVariables, TContext, TCache>(args[0], {
    client: actualClient,
    ...args?.[1],
  });
};

export const useQuery = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  client: ClientsType,
  ...args: Parameters<typeof apollo.useQuery>
) => {
  const actualClient = useClient(client);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return apollo.useQuery<TData, TVariables>(args[0], {
    client: actualClient,
    ...args?.[1],
  });
};

export { apollo };
export { setContext };
export { onError };
